<template>
    <div>

        <h3>Документы</h3>

        <a class="file-link" v-for="(file, i) of files" :key="i" :href="'/' + file.path" rel="noopener noreferrer" target="_blank">
            <fa-icon size="2x" class="icon" :icon="faFilePdf"></fa-icon>
            Скачать {{fileTypes[file.type]}}

            <span class="file-info">({{file.path | fileext}} {{file.size | filesize}})</span>
        </a>
    </div>
</template>

<script>

import {faFilePdf} from '@fortawesome/free-regular-svg-icons/faFilePdf'

export default {
    props: ['files'],
    data: () => ({
        fileTypes: ['паспорт', 'спецификацию', 'декларацию'],
        faFilePdf
    }),
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/colors.scss';

.file-link {
    display: flex;
    align-items: center;
    color: $color-text;
    margin-top: 15px;

    .icon {
        margin-right: 20px;
        transition: color .2s ease;
    }

    .file-info {
        margin-left: 20px;
        font-size: 14px;
        color: $color-text-light;
    }

    &:hover .icon {
        color: $color-text-red;
    }
}


</style>